import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="main-container">
      <div
        className="card mx-auto text-center"
        style={{ maxWidth: 480, padding: '3rem 2rem' }}
      >
        <div
          style={{
            width: 80,
            height: 80,
            margin: '0 auto 1.5rem',
            borderRadius: 20,
            background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
            color: '#fff',
            display: 'grid',
            placeItems: 'center',
            fontSize: 34,
            boxShadow: '0 8px 24px rgba(79,70,229,0.25)',
          }}
        >
          <i className="fas fa-compass"></i>
        </div>
        <h1 style={{ fontSize: '3rem', fontWeight: 800, margin: 0, color: 'var(--primary)' }}>
          404
        </h1>
        <p className="text-muted mt-2 mb-4">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-cta">
          <i className="fas fa-home me-1"></i>Back to home
        </Link>
      </div>
    </div>
  );
}
